import request from '@/utils/request';
import config from '../config.js';

const baseUrl = config.debug ? 'http://haofenqi-mapi-enva.test.rrdbg.com' : '';
// const baseUrl = 'http://127.0.0.1:7001'

export function getArticleList (data) {
  return request({
    url: baseUrl + '/api/v1/article/query-by-category',
    method: 'post',
    data
  });
}
export function getBannerList (data) {
  return request({
    url: baseUrl + '/api/v1/weicai-home/banner',
    method: 'post',
    data
  });
}
export function getNewsDetail (data) {
  return request({
    url: baseUrl + '/api/v1/article/queryById',
    method: 'post',
    data
  });
}
export function getCMSGuideInfo () {
  return request({
    url: baseUrl + '/api/staticProtocol/getContentById?code=fraudPreventionGuide-weicai',
    method: 'get'
  });
}

// 获取基础信息
export function getStaticConfig (data) {
  return request({
    url: baseUrl + '/api/v1/static/config',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/home.js